import React, { useEffect, useState } from 'react'
// import { ControlLabel } from 'react-bootstrap'
// import { Typeahead } from 'react-bootstrap-typeahead'
import axios from 'axios'
import getServerURL from '../../../../functions/getServerURL'
import '../style.css'
import LoadingAnimation from "../../../../reuseable-components/LoadingAnimation"


export default function Materials({ selectedTraining }) {
  // STATE
  const [materials, setMaterials] = useState([])
  const [loadingMaterials, setLoadingMaterials] = useState(false)
  // const [showMaterialsDropdown, setShowMaterialsDropdown] = useState(false)
  // const [selectedMaterial, setSelectedMaterial] = useState(null)

  const getTrainingMaterials = () => {
    setLoadingMaterials(true)
    axios.get(`${getServerURL()}training-documents/?training=${selectedTraining.id}`, {
      headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` }
    }).then(response => {
      setMaterials(response.data)
      // if (response.data.length) {
      //   if (response.data.length > 1) {
      //     setShowMaterialsDropdown(true)
      //   }
      //   setSelectedMaterial(response.data[0])
      // } else {
      //   setShowMaterialsDropdown(false)
      // }
    }).catch(error => {
      console.log(error)
    }).finally(() => setLoadingMaterials(false))
  }

  const renderIframe = () => {
    if (loadingMaterials) {
      return <LoadingAnimation />
    }
    // if (!!selectedMaterial) {
    //   return (
    //     <iframe
    //       src={ `${selectedMaterial.document}#view=FitH&toolbar=0` }
    //       title={ selectedMaterial.name }
    //       style={{ height: '90vh', width: '100%', background: '#fff' }}
    //     >
    //     </iframe>
    //   )
    if (materials) {
      return (
        <ul style={{ listStyle: "none" }}>
          { materials.map(material => {
            return (
              <li key={material.id}>
                <a href={ material.document_url } target="_blank">{ material.name }</a>
              </li>
            )
          })}
        </ul>
      )
    } else {
      return (
        <h5>There are no materials for this training.</h5>
      )
    }
  }

  useEffect(() => {
    getTrainingMaterials()
  }, [])

  return (
    <div>
      <h5>Training Materials:</h5>
      {/*<div className="form-input-container">*/}
      {/*  { showMaterialsDropdown &&*/}
      {/*    <React.Fragment>*/}
      {/*      <ControlLabel>*/}
      {/*        Select Material*/}
      {/*      </ControlLabel>*/}
      {/*      <Typeahead*/}
      {/*        style={{ margin: "25px" }}*/}
      {/*        id='SelectMaterialTypeahead'*/}
      {/*        labelKey={ material => material.name }*/}
      {/*        options={ materials }*/}
      {/*        selected={ selectedMaterial ? [ selectedMaterial ] : [] }*/}
      {/*        onChange={ (material) => setSelectedMaterial(material[0] || null) }*/}
      {/*        placeholder="Select training material"*/}
      {/*      />*/}
      {/*    </React.Fragment>*/}
      {/*  }*/}
      {/*</div>*/}
      { renderIframe() }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTraining/Materials/index.js